<template>
  <div class="hotsite-configuration-fields">
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Pessoa física</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <mf-icon :icon="isNaturalEnabled ? 'check_circle' : 'cancel'" :color="isNaturalEnabled ? 'verde-l20' : 'vermelho-l20'" size="sm" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <hotsite-person-type-fields person-type="N" person-type-label="Pessoa física" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Pessoa jurídica</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <mf-icon :icon="isLegalEnabled ? 'check_circle' : 'cancel'" :color="isLegalEnabled ? 'verde-l20' : 'vermelho-l20'" size="sm" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <hotsite-person-type-fields person-type="L" person-type-label="Pessoa jurídica" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HotsiteConfigurationFields',
  components: {
    HotsitePersonTypeFields: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/HotsitePersonTypeFields.vue'),
  },
  computed: {
    ...mapGetters('hotsiteConfiguration', ['fieldsWithDefaults']),
    isNaturalEnabled() {
      const allowedTypes = this.fieldsWithDefaults?.allowed_person_types_signup || []
      return allowedTypes.includes('N')
    },
    isLegalEnabled() {
      const allowedTypes = this.fieldsWithDefaults?.allowed_person_types_signup || []
      return allowedTypes.includes('L')
    },
  },
}
</script>
